package com.yogaaicoach.pages.workout.data

import com.yogaaicoach.common.network.ApiClient
import com.yogaaicoach.pages.workout.data.models.CompleteWorkoutRequest
import com.yogaaicoach.pages.workout.data.models.GetFocusAreasResponse
import com.yogaaicoach.pages.workout.data.models.PostWorkoutFeedbackRequest
import com.yogaaicoach.pages.workout.data.models.UpdateWorkoutRequest
import com.yogaaicoach.pages.workout.data.models.WorkoutDataDto
import io.ktor.http.*
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

class WorkoutApi(private val client: ApiClient) {

    @OptIn(ExperimentalUuidApi::class)
    suspend fun getWorkoutData(workoutGuid: Uuid): WorkoutDataDto? {
        return client.makeRequest(
            url = "${Config.API_URL}/workoutData?workoutGuid=$workoutGuid",
            method = HttpMethod.Get
        )
    }

    @OptIn(ExperimentalUuidApi::class)
    suspend fun getFocusAreas(workoutGuid: Uuid): GetFocusAreasResponse? {
        return client.makeRequest(
            url = "${Config.API_URL}/focusAreas?workoutGuid=$workoutGuid",
            method = HttpMethod.Get
        )
    }

    suspend fun completeWorkout(requestBody: CompleteWorkoutRequest): Unit? {
        return client.makeRequest(
            url = "${Config.API_URL}/completeWorkout",
            method = HttpMethod.Post,
            body = requestBody
        )
    }

    suspend fun updateWorkout(requestBody: UpdateWorkoutRequest): Unit? {
        return client.makeRequest(
            url = "${Config.API_URL}/updateWorkout",
            method = HttpMethod.Post,
            body = requestBody
        )
    }

    suspend fun postWorkoutFeedback(requestBody: PostWorkoutFeedbackRequest): Unit? {
        return client.makeRequest(
            url = "${Config.API_URL}/workoutFeedback",
            method = HttpMethod.Post,
            body = requestBody
        )
    }
}